import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { usePopper } from 'react-popper2';
import { useIsomorphicLayoutEffect } from 'react-use';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useTooltipTimers = function useTooltipTimers(props) {
  var delay = props.delay,
      setShowTooltip = props.setShowTooltip,
      toggle = props.toggle,
      toggleCallback = props.toggleCallback;

  var getDelay = function getDelay(key) {
    if (_typeof(delay) === 'object') {
      return Number.isNaN(delay[key]) ? 0 : delay[key];
    }

    return Number.isNaN(delay) ? 0 : delay;
  };

  var showTimer = useRef();
  var hideTimer = useRef();

  var clearTimers = function clearTimers() {
    clearTimeout(showTimer.current);
    showTimer.current = null;
    clearTimeout(hideTimer.current);
    hideTimer.current = null;
  };

  var show = function show(e) {
    setShowTooltip(true);
    toggleCallback(e, true);
  };

  var hide = function hide(e) {
    setShowTooltip(false);
    toggleCallback(e, false);
  };

  var eventHandler = function eventHandler(e) {
    switch (e.type) {
      case 'mouseover':
        clearTimers();
        showTimer.current = setTimeout(function () {
          show(e);
        }, getDelay('show'));
        break;

      case 'mouseout':
        clearTimers();
        showTimer.current = setTimeout(function () {
          hide(e);
        }, getDelay('hide'));
        break;

      case 'focusin':
        show(e);
        break;

      case 'focusout':
        hide(e);
        break;

      case 'click':
        toggle(e);
        break;

      case 'keydown':
        if (e.key === 'Escape') {
          setShowTooltip(false);
          toggleCallback(e, false);
        }

        break;
    }
  };

  return eventHandler;
};

var useTooltip = function useTooltip(props) {
  var _classNames;

  var className = props.className,
      delay = props.delay,
      hideArrow = props.hideArrow,
      isOpen = props.isOpen,
      modifiers = props.modifiers,
      placement = props.placement,
      size = props.size,
      target = props.target,
      targetIsFunctional = props.targetIsFunctional,
      toggleCallback = props.toggle;
  var popperRef = useRef();

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      arrowElement = _useState2[0],
      setArrowElement = _useState2[1];

  var _usePopper = usePopper(target, popperRef.current, {
    placement: placement,
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 8]
      }
    }].concat(_toConsumableArray(modifiers))
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var _useState3 = useState(isOpen),
      _useState4 = _slicedToArray(_useState3, 2),
      showTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  var toggle = function toggle(e) {
    setShowTooltip(!showTooltip);
    toggleCallback(e, !showTooltip);
  };

  var isTouchDevice = typeof document.body.ontouchstart !== 'undefined';
  var events = [];

  if (!(targetIsFunctional && isTouchDevice)) {
    events.push('keydown', 'focusin', 'focusout', 'mouseover', 'mouseout');
  }

  if (!targetIsFunctional) {
    events.push('click');
  }

  var eventHandler = useTooltipTimers({
    delay: delay,
    setShowTooltip: setShowTooltip,
    toggle: toggle,
    toggleCallback: toggleCallback
  });

  var addEventListeners = function addEventListeners() {
    events.forEach(function (event) {
      target.addEventListener(event, eventHandler, true);
    });
  };

  var removeEventListeners = function removeEventListeners() {
    events.forEach(function (event) {
      target.removeEventListener(event, eventHandler, true);
    });
  };

  useEffect(function () {
    addEventListeners();
    return function () {
      return removeEventListeners();
    };
  }, []);
  var computedPopperClassName = classNames((_classNames = {
    'prism-tooltip': true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "tooltip-".concat(size), size), _classNames));
  return {
    showTooltip: showTooltip,
    tooltipProps: _objectSpread2({
      ref: popperRef,
      style: styles.popper,
      className: computedPopperClassName
    }, attributes.popper),
    arrowProps: {
      ref: setArrowElement,
      style: _objectSpread2(_objectSpread2({}, styles.arrow), {}, {
        display: hideArrow ? 'none' : 'block'
      }),
      className: 'tooltip-arrow'
    }
  };
};

var _excluded$1 = ["children"];

var Tooltip$1 = function Tooltip(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var _useTooltip = useTooltip(props),
      showTooltip = _useTooltip.showTooltip,
      tooltipProps = _useTooltip.tooltipProps,
      arrowProps = _useTooltip.arrowProps;

  return showTooltip ? /*#__PURE__*/React.createElement("div", _extends({
    role: "tooltip"
  }, tooltipProps), children, /*#__PURE__*/React.createElement("div", arrowProps)) : null;
};

var TooltipSizes = ['sm', 'lg'];
Tooltip$1.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  delay: PropTypes.oneOfType([PropTypes.shape({
    show: PropTypes.number,
    hide: PropTypes.number
  }), PropTypes.number]),
  hideArrow: PropTypes.bool,
  isOpen: PropTypes.bool,
  modifiers: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  placement: PropTypes.oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end']),
  size: PropTypes.oneOf(TooltipSizes),
  target: PropTypes.node.isRequired,
  targetIsFunctional: PropTypes.bool,
  toggle: PropTypes.func
};
Tooltip$1.defaultProps = {
  children: null,
  className: '',
  delay: 0,
  hideArrow: false,
  isOpen: false,
  modifiers: [],
  placement: 'bottom',
  size: 'lg',
  targetIsFunctional: false,
  toggle: function toggle() {}
};

var _excluded = ["disabled", "target"];

var TooltipWrapper = function TooltipWrapper(_ref) {
  var disabled = _ref.disabled,
      target = _ref.target,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      computedTarget = _useState2[0],
      setComputedTarget = _useState2[1];

  useIsomorphicLayoutEffect(function () {
    var newComputedTarget;

    if (target.current) {
      newComputedTarget = target.current;
    } else if (typeof target === 'function') {
      newComputedTarget = target();
    } else if (typeof target === 'string') {
      newComputedTarget = document.getElementById(target);
    } else {
      newComputedTarget = target;
    }

    setComputedTarget(newComputedTarget);
  }, [target]);
  return !disabled && computedTarget ? /*#__PURE__*/React.createElement(Tooltip$1, _extends({
    target: computedTarget
  }, props)) : null;
};

TooltipWrapper.propTypes = {
  disabled: PropTypes.bool,
  target: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node, PropTypes.shape({
    current: PropTypes.element
  })])
};
TooltipWrapper.defaultProps = {
  disabled: false,
  target: null
};

var Tooltip = TooltipWrapper;

export { TooltipSizes, Tooltip as default, useTooltip };
//# sourceMappingURL=index.js.map
